import { roles } from '@nxsys/store/constants';
import Reports from '../../../modules/reports';

export const reportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports',
    element: <Reports />,
  },
];
